import { useMutation } from "@tanstack/react-query";
import { deactivateBloomreach } from "../../api/bBloomreachApi";

export const useDeactivateBloomreach = () => {
  return useMutation({
    mutationKey: ["deactivate-bloomreach"],
    mutationFn: (data) => deactivateBloomreach(data),
  });
};
